import React, { useState } from "react";
import {
  correctColor,
  fixOptions,
  missingColor,
  NumberToLetter,
  tenzero,
} from "../../constants/Constants";
import Latex from "react-latex-next";
import Text from "../../components/common/Text";
import Div from "../../components/common/Div";
import InputBox from "../../components/common/InputBox";
import Image from "../../components/common/Image";
import { Tex } from "react-tex";

export default function M_ColumnMatch(props) {
  const [selectedInput, setSelectedInput] = useState(-1);

  const question = props.question;
  const options = question.options;

  function Options() {
    let arr = [];
    for (var i = 0; i < options.length; i++) {
      const letter = NumberToLetter(i);

      const getTex = () => {
        return <Tex texContent={fixOptions("", options[i].text)} />;
      };

      const texCon = options[i].text !== null ? getTex() : <></>;
      const value = (
        <div key={"Text".concat(letter)}>
          <div style={{ display: "flex" }}>
            <div
              style={{
                flex: 3,
                textAlign: "right",
                paddingRight: "0.5em",
                paddingTop: "-9px",
                fontSize: "0.9rem",
              }}
            >
              <text style={{ fontSize: "0.9rem" }}>{letter.concat(". ")}</text>
            </div>
            <div style={{ flex: 17, textAlign: "left", fontSize: "0.9rem" }}>
              <div style={{ marginTop: "auto", marginBottom: "auto" }}>
                {texCon}
              </div>
              <Image src={options[i].url} width="150px" />
            </div>
          </div>
        </div>
      );
      arr.push(value);
    }
    return <Div>{arr}</Div>;
  }

  function getColumnMatches() {
    var matches = [];
    for (var x = 0; x < options.length; x++) {
      var el = (
        <>
          <tr>
            <td width="85%">
              <Latex>{options[x].description}</Latex>
            </td>
            <td>
              <div
                style={{ backgroundColor: correctColor(), textAlign: "center" }}
              >
                <text>{NumberToLetter(x)}</text>
              </div>
            </td>
          </tr>
        </>
      );
      matches[x] = el;
    }

    return matches;
  }

  return (
    <div>
      {Options()}
      <table width={"80%"}>{getColumnMatches()}</table>
    </div>
  );
}
